import React, { FC } from 'react';
import Typo from '../Typography/Typo';

type TPromptDetailsDistanceTimerProps = {
  formattedDistanceText: string;
};

export const PromptDetailsDistanceTimer: FC<TPromptDetailsDistanceTimerProps> = ({ formattedDistanceText }) => (
  <Typo
    variant="p2"
    className="relative ml-7 font-semibold before:absolute before:bg-calendar before:w-5 before:h-5 before:-left-7 before:top-1/2 before:-translate-y-1/2"
  >
    {formattedDistanceText}
  </Typo>
);
